import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

const getBrowserLocale = () => {
  const preferred = navigator.language || navigator.languages?.[0] || "ru";
  return preferred.toLowerCase().startsWith("ru") ? "ru" : "en";
};

const translations = {
  ru: {
    title: "Использование cookies",
    text: "Мы используем технические cookie-файлы (сессия, CSRF, язык интерфейса) для корректной работы сайта. Сбор рекламных, аналитических или иных несущественных cookie без отдельного согласия не осуществляется. Подробнее в ",
    link: "Политике конфиденциальности",
    accept: "Согласен",
    reject: "Отклонить",
  },
  en: {
    title: "Use of cookies",
    text: "We use technical cookies (session, CSRF, interface language) to ensure the proper functioning of the site. We do not collect advertising, analytical or other non-essential cookies without separate consent. Learn more in the ",
    link: "Privacy Policy",
    accept: "Accept",
    reject: "Reject",
  },
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const locale = getBrowserLocale();
  const text = translations[locale] || translations.ru;

  useEffect(() => {
    const consent = Cookies.get("cookie_consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const setConsent = (value) => {
    Cookies.set("cookie_consent", value, {
      expires: 365,
      sameSite: "Lax",
      secure: window.location.protocol === "https:",
    });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2000,
        background: "#1f2937",
        color: "#fff",
        padding: "18px 20px",
        boxShadow: "0 -8px 30px rgba(0,0,0,0.2)",
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
        <div style={{ flex: 1, minWidth: 240 }}>
          <strong>{text.title}</strong>
          <div style={{ fontSize: 14, marginTop: 4, lineHeight: 1.5 }}>
            {text.text}
            <a href="/privacy" style={{ color: "#dbeafe" }}>{text.link}</a>.
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={() => setConsent("accepted")}
            style={{
              background: "#2d6cdf",
              color: "#fff",
              border: 0,
              borderRadius: 6,
              padding: "10px 16px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            {text.accept}
          </button>
          <button
            type="button"
            onClick={() => setConsent("rejected")}
            style={{
              background: "transparent",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.4)",
              borderRadius: 6,
              padding: "10px 16px",
              cursor: "pointer",
            }}
          >
            {text.reject}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
